import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CreatableSelect from "react-select/creatable";
export default function FilterModal({
  show,
  onHide,

  statusFilter,
  setStatusFilter,

  staffTypeFilter,
  setStaffTypeFilter,

  clientFilter,
  setClientFilter,

  monthFilter,
  setMonthFilter,

  rentalFilter,
  setRentalFilter,

  userSourceFilter,
  setUserSourceFilter,

  thirdPartyProviderFilter,
  setThirdPartyProviderFilter,

  providerOptions = [],

  applyFilters,
  removeFilters,
  clients,
  staffTypes,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* ✅ CLIENT FILTER (FROM API, NOT APIDATA) */}
          <Form.Group controlId="clientFilter" className="mt-3">
            <Form.Label>Clients</Form.Label>

            <div
              className="border rounded p-2"
              style={{ maxHeight: "150px", overflowY: "auto" }}
            >
              {clients
                ?.filter((c) => c.status === "Active")
                .map((client) => (
                  <Form.Check
                    key={client._id}
                    type="checkbox"
                    label={client.name}
                    value={client._id}
                    checked={clientFilter.includes(client._id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setClientFilter([...clientFilter, client._id]);
                      } else {
                        setClientFilter(
                          clientFilter.filter((c) => c !== client._id),
                        );
                      }
                    }}
                    className="mb-1"
                  />
                ))}
            </div>
          </Form.Group>

          {/* ✅ STATUS FILTER */}
          <Form.Group controlId="statusFilter" className="mt-3">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Control>
          </Form.Group>

          {/* ✅ STAFF TYPE FILTER (FROM API) */}
          <Form.Group controlId="staffTypeFilter" className="mt-3">
            <Form.Label>Staff Type</Form.Label>

            <Form.Control
              as="select"
              value={staffTypeFilter}
              onChange={(e) => setStaffTypeFilter(e.target.value)}
            >
              <option value="">All Staff Types</option>

              {Array.isArray(staffTypes) &&
                staffTypes.map((type) => (
                  <option key={type._id} value={type._id}>
                    {type.name}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>

          {/* ✅ MONTH FILTER */}
          <Form.Group controlId="monthFilter" className="mt-3">
            <Form.Label>Onboarding Month</Form.Label>
            <DatePicker
              selected={monthFilter}
              onChange={(date) => setMonthFilter(date)}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              placeholderText="📅 Select Month & Year"
              className="form-control"
              wrapperClassName="d-block"
            />
          </Form.Group>

          <Form.Group controlId="rentalFilter" className="mt-3">
            <Form.Label>Rental</Form.Label>

            <Form.Control
              as="select"
              value={rentalFilter}
              onChange={(e) => setRentalFilter(e.target.value)}
            >
              <option value="">All Users</option>
              <option value="true">Rental Users</option>
              <option value="false">Non Rental Users</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="userSourceFilter" className="mt-3">
            <Form.Label>User Source</Form.Label>

            <Form.Control
              as="select"
              value={userSourceFilter}
              onChange={(e) => setUserSourceFilter(e.target.value)}
            >
              <option value="">All User Sources</option>
              <option value="InHouse">In-House</option>
              <option value="ThirdParty">Third Party</option>
            </Form.Control>
          </Form.Group>

          {/* THIRD-PARTY PROVIDER FILTER */}
          <Form.Group controlId="thirdPartyProviderFilter" className="mt-3">
            <Form.Label>Third-Party Provider</Form.Label>

            <CreatableSelect
              inputId="thirdPartyProviderFilter"
              name="thirdPartyProviderFilter"
              options={providerOptions}
              placeholder="Search or select a provider..."
              isClearable
              value={
                thirdPartyProviderFilter
                  ? {
                      value: thirdPartyProviderFilter,
                      label: thirdPartyProviderFilter,
                    }
                  : null
              }
              formatCreateLabel={(inputValue) =>
                `Use provider: "${inputValue.trim()}"`
              }
              onChange={(option) => {
                setThirdPartyProviderFilter(option?.value || "");
              }}
              onCreateOption={(inputValue) => {
                const providerName = inputValue.trim();

                if (!providerName) return;

                const existingProvider = providerOptions.find(
                  (option) =>
                    option.value.trim().toLowerCase() ===
                    providerName.toLowerCase(),
                );

                setThirdPartyProviderFilter(
                  existingProvider?.value || providerName,
                );
              }}
              classNamePrefix="select"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>

        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
